import type { CreditCard, User } from 'models';
import {
  CREATE_USER_SUCCESS,
  FETCH_CREDIT_CARDS_SUCCESS,
  FETCH_USER_SUCCESS,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER_SUCCESS,
  REMOVE_CREDIT_CARD_SUCCESS,
  UPDATE_USER_SUCCESS,
} from '../../../constants';

type UserAction =
  | {
      type:
        | typeof CREATE_USER_SUCCESS
        | typeof FETCH_CREDIT_CARDS_SUCCESS
        | typeof FETCH_USER_SUCCESS
        | typeof UPDATE_USER_SUCCESS;
      payload: User;
    }
  | {
      type: typeof LOGIN_USER_SUCCESS;
      payload: {
        user: User;
      };
    }
  | {
      type: typeof FETCH_CREDIT_CARDS_SUCCESS;
      payload: CreditCard[];
    }
  | {
      type: typeof REMOVE_CREDIT_CARD_SUCCESS;
      payload: string;
    }
  | {
      type: typeof LOGOUT_USER_SUCCESS;
    };

const user = (state: User | Record<string, never> = {}, action: UserAction) => {
  switch (action.type) {
    case CREATE_USER_SUCCESS:
    case FETCH_USER_SUCCESS:
    case UPDATE_USER_SUCCESS:
      return { ...state, ...action.payload };
    case LOGIN_USER_SUCCESS:
      const {
        payload: { user },
      } = action;
      return { ...state, ...user };
    case LOGOUT_USER_SUCCESS:
      return {};
    case FETCH_CREDIT_CARDS_SUCCESS: {
      return {
        ...state,
        creditCards: action.payload,
      };
    }
    case REMOVE_CREDIT_CARD_SUCCESS: {
      return {
        ...state,
        creditCards: state.creditCards.filter(
          card => card.token !== action.payload,
        ),
      };
    }
    default:
      return state;
  }
};

export { user };
